import(/* webpackMode: "eager" */ "/workspace/app/(profile)/wishlist/components/Wishlist.jsx")